/** Let Escape dismiss hover/focus readouts without moving keyboard focus. */
export function initializeLineCharts(root) {
    const points = [...root.querySelectorAll('.blog-line-chart__point')];
    if (!points.length) return () => {};
    const show = (event) => delete event.currentTarget.dataset.dismissed;
    const dismiss = (event) => {
        if (event.key !== 'Escape') return;
        points.forEach((point) => {
            if (point.matches(':hover, :focus')) point.dataset.dismissed = '';
        });
    };
    points.forEach((point) => {
        point.addEventListener('pointerenter', show);
        point.addEventListener('focus', show);
        point.addEventListener('click', show);
    });
    document.addEventListener('keydown', dismiss);
    return () => {
        document.removeEventListener('keydown', dismiss);
        points.forEach((point) => {
            point.removeEventListener('pointerenter', show);
            point.removeEventListener('focus', show);
            point.removeEventListener('click', show);
        });
    };
}
